import React from 'react';
import AudiLogo from '../assets/logos/Audi.png';
import MercedesLogo from '../assets/logos/Mercedes-benz.png';
import VolkswagenLogo from '../assets/logos/Volkswagen.png';
import KiaLogo from '../assets/logos/Kia.png';
import BMWLogo from '../assets/logos/BMW.png';
import RenaultLogo from '../assets/logos/Renault.png';
import HyndaiLogo from '../assets/logos/Hyundai.png';
import CitroenLogo from '../assets/logos/Citroen.png';
import VolvoLogo from '../assets/logos/Volvo.png';
import Highlight from './Highlight';
import ArrowLeft  from '../assets/icons/Arrow3';
import ArrowRight from '../assets/icons/Arrow4';

const carBrands = [
  { name: 'Audi', icon: AudiLogo },
  { name: 'BMW', icon: BMWLogo },
  { name: 'Mercedes', icon: MercedesLogo },
  { name: 'Volkswagen', icon: VolkswagenLogo },
  { name: 'Citroen', icon: CitroenLogo },
  { name: 'Volvo', icon: VolvoLogo },
  { name: 'Renault', icon: RenaultLogo },
  { name: 'Kia', icon: KiaLogo },
  { name: 'Hyundai', icon: HyndaiLogo },
];

const CarBrandGrid = () => (
  <div style={styles.carBrandSection}>
    <div style={styles.highlightWrapper}>
      <Highlight width={1460} height={360} />
    </div>
    <div style={styles.content}>
      <h3 style={styles.heading}>Najpopularniji brendovi automobila</h3>
      <div style={styles.arrowLeft}>
        <ArrowLeft />
      </div>
      <div style={styles.grid}>
        {carBrands.map((brand, index) => (
          <div key={index} style={styles.card}>
            <img src={brand.icon} alt={brand.name} style={styles.icon} />
          </div>
        ))}
      </div>
      <div style={styles.arrowRight}>
        <ArrowRight />
      </div>
    </div>
  </div>
);

export default CarBrandGrid;

const styles = {
  carBrandSection: {
    marginBottom: '100px',
    borderRadius: '24px',
    padding: '20px',
    textAlign: 'center',
    margin: '0 auto',
    width: 1460,
    height: 360,
    position: 'relative',
    backgroundColor:'rgb(23, 23, 24)'
  },
  highlightWrapper: {
    position: 'absolute',
    top: 20,
    left: 20,
    width: '100%',
    height: '100%',
    zIndex: 1,
  },
  content: {
    position: 'relative',
    zIndex: 2,
    backgroundImage: 'linear-gradient(232deg, rgba(153, 153, 153, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%)',
    padding: '20px',
    borderRadius: '12px',
    width: '100%',
    height: '100%',
    backdropFilter: 'blur(6px)',
  },
  heading: {
    fontSize: '48px',
    fontWeight: 700,
    backgroundImage: 'linear-gradient(235.42deg, #EEFF00 0%, #B6BB6C 100%)',
    backgroundClip: 'text',
    color: 'transparent',
    marginBottom: 50,
    lineHeight: '48px',
  },
  grid: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: '20px 0',
    width: '100%',
  },
  card: {
    width: '100px',
    height: '100px',
    display: 'flex',
    justifyContent: 'center',
    flexShrink: 0,
  },
  icon: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  arrowLeft: {
    position: 'absolute',
    top: '60%',
    left: '20px',  
    zIndex: 3,
    cursor: 'pointer',
  },
  arrowRight: {
    position: 'absolute',
    top: '60%',
    right: '20px', 
    zIndex: 3,
    cursor: 'pointer',
  },
};
